export function formatDateTime({ date, withTime = false, timeOnly = false, timeSeparator = "," }) {
  const d = new Date(date);

  if (timeOnly) {
    return d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  let formatted = d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });

  if (withTime) {
    const time = d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    formatted = `${formatted}${timeSeparator} ${time}`;
  }

  return formatted;
}